import { localizedText } from "../helpers/localization"
import { Controller } from "@hotwired/stimulus"

const RESET_DELAY = 2000

export default class extends Controller {
  static targets = ["source", "label"]

  connect() {
    this.defaultLabel = this.hasLabelTarget ? this.labelTarget.textContent : null
  }

  disconnect() {
    clearTimeout(this.resetTimer)
  }

  async copy(event) {
    event.preventDefault()

    const text = event.currentTarget.dataset.copyText || event.currentTarget.dataset.toolCopyText || this.sourceText
    if (!text) return

    await navigator.clipboard.writeText(text)
    this.#showCopied()
  }

  get sourceText() {
    if (!this.hasSourceTarget) return ""

    return this.sourceTarget.textContent.trim()
  }

  #showCopied() {
    if (!this.hasLabelTarget) return

    this.labelTarget.textContent = localizedText(this.element, "copied")
    clearTimeout(this.resetTimer)
    this.resetTimer = setTimeout(() => {
      this.labelTarget.textContent = this.defaultLabel
    }, RESET_DELAY)
  }
}
